import * as Yup from 'yup';
import validation from 'modules/v2/common/validationSchema';

const validationSchema = Yup.object().shape({
  segments: validation.segments,
  sendImmediately: Yup.boolean(),
});

export default validationSchema;
